import React, { useEffect, useState } from 'react';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import NewItemMonthPanel from '../NewItemMonthPanel/NewItemMonthPanel';
import './CostPerDay.css'
import CostDayPanelDetail from './DetailPanelCostPerDay/Item/CostDayPanelDetail';
import SalaryDayPanelDetail from './DetailPanelCostPerDay/Salary/SalaryDayPanelDetail';
import NewSalaryMonthPanel from '../NewSalaryMonthPanel/NewSalaryMonthPanel';
import NewBenefitMonthPanel from '../NewBenefitMonthPanel/NewBenefitMonthPanel';
import BenefitsDayPanel from './DetailPanelCostPerDay/Benefit/BenefitsDayPanel';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';
import RevenueDayPanel from './DetailPanelCostPerDay/Revenue/RevenueDayPanel';
import Panel from 'Components/Panel/Panel';
import ExternalProductionCost from './DetailPanelCostPerDay/ExternalProductionCost/ExternalProductionCost';
import ExternalEmployeeList from './DetailPanelCostPerDay/ExternalProductionCost/ExternalEmployeeList';

const CostPerDay = (
    {
        showDetailItem,
        itemInValidation,
        closingCostPerDay,
        onUpdateItemInValidation,
        onUpdatePanelCostSpreadsheet,
        onUpdateRowIndexSelected,
        onUpdateClosingCostPerDay,
        onUpdateCloseCostSpreadsheet,
        handleClose,
        closeCostSpreadsheet
    }) => {
    const [costDayIdSelecteds, setCostDayIdSelecteds] = useState([]);

    const [itemsDays, setItemsDays] = useState(null)
    const [dsItem, setDsItem] = useState(null)
    const [dsMonth, setDsMonth] = useState(null)
    const [updating, setUpdating] = useState(false)
    const [reloadSalarybenefitsCost, setReloadSalaryBenefitsCost] = useState(false)
    const [identifierExternalProduction, setIdentifierExternalProduction] = useState(false)

    const [showNewItemMonthPanel, setShowNewItemMonthPanel] = useState(false);
    const [showNewSalaryMonthPanel, setShowNewSalaryMonthPanel] = useState(false);
    const [showNewRevenueMonthPanel, setShowNewRevenueMonthPanel] = useState(false);
    const [showNewBenefitMonthPanel, setShowNewBenefitMonthPanel] = useState(false);

    const [idEmployee, setIdEmployee] = useState(null)

    const attributeList = [
        { name: "id", value: costDayIdSelecteds, setter: setCostDayIdSelecteds, allowsMultipleRecordsSelected: (!itemInValidation ? false : !([6]).includes(itemInValidation.key)) },
    ];

    useEffect(() => {
        setReloadSalaryBenefitsCost(false)
        const fetchData = async () => {
            if (itemInValidation) {
                const parameters = {
                    itemId: itemInValidation.key,
                    currentMonth: new Date(itemInValidation.currentMonth)
                }
                const resultItemsDays = await ExecuteAxios.api('get', '/build-grid/salary-benefits-cost/', { params: parameters });

                if (resultItemsDays && resultItemsDays.length > 0) {
                    setItemsDays(resultItemsDays);
                } else {
                    setItemsDays(null);
                }

                setDsMonth(itemInValidation.month);

                const dsItem = await ExecuteAxios.api('get', '/item-cost/desc-item-cost-by-id/', {
                    params: {
                        id: itemInValidation.key,
                    }
                });
                setDsItem(dsItem);
            } else {
                setItemsDays(null);
                setDsItem(null);
            }
        }
        fetchData();
    }, [itemInValidation, updating, reloadSalarybenefitsCost === true])

    useEffect(() => {
        setItemsDays(null)
        setCostDayIdSelecteds([])
        setUpdating(false)
    }, [itemInValidation])

    useEffect(() => {
        const fetchData = async () => {
            let identifier
            try {
                identifier = await ExecuteAxios.api('get', `/general-settings/selected-external-item-identifier/`)
                setIdentifierExternalProduction(identifier)
            } catch {
                setIdentifierExternalProduction(null)
            }
        }
        fetchData();
    }, [])

    function getColorStyle(valueToDisplay) {
        let colorStyle;
        if (valueToDisplay === 0) {
            colorStyle = { backgroundColor: 'purple' };
        } else if (valueToDisplay === 1) {
            colorStyle = { backgroundColor: 'green' };
        } else if (valueToDisplay === 2) {
            colorStyle = { backgroundColor: 'red' };
        }

        return (
            <div
                style={{
                    width: '15px',
                    height: '15px',
                    borderRadius: '50%',
                    display: 'inline-block',
                    ...colorStyle
                }}
            ></div>
        )
    }

    const [showSubtitles, setShowSubtitles] = useState(false);

    const toggleSubtitles = () => {
        setShowSubtitles(!showSubtitles);
    };

    const subtitlesStyleCostPerDay = {
        padding: "5px",
        cursor: 'default'
    };

    const subtitleDescriptionStyleCostPerDay = {
        marginLeft: "10px"
    };

    function getSubtitlesContent() {
        return (
            <div style={{ backgroundColor: '#f5f5f5' }}>
                <div style={subtitlesStyleCostPerDay}>
                    {getColorStyle(0)}
                    <span style={subtitleDescriptionStyleCostPerDay}>Pendente valor real</span>
                </div>
                <div style={subtitlesStyleCostPerDay}>
                    {getColorStyle(1)}
                    <span style={subtitleDescriptionStyleCostPerDay}>Orçamento dentro do limite </span>
                </div>
                <div style={subtitlesStyleCostPerDay}>
                    {getColorStyle(2)}
                    <span style={subtitleDescriptionStyleCostPerDay}>Orçamento excedeu o limite </span>
                </div>
            </div>
        );
    }

    function getButtonToShowSubtitles() {
        return (
            <div className="main-balloon-cost-per-day" style={{ background: '#f5f5f5' }}>
                <div style={{ position: 'absolute', bottom: '0px' }}>
                    {showSubtitles && (
                        <div className="balloon-cost-per-day">
                            {getSubtitlesContent()}
                        </div>
                    )}
                    <div className="title-balloon-cost-per-day"
                        onClick={toggleSubtitles}
                    >
                        Legenda
                    </div>
                </div>
            </div>
        );
    }

    function onUpdateInsertSalary(value) {
        if (value) {
            setShowNewItemMonthPanel(false)
            setShowNewBenefitMonthPanel(false)
            setShowNewSalaryMonthPanel(true)
            setShowNewRevenueMonthPanel(false)
        }
    }

    function onUpdateInsertBenefit(value) {
        if (value) {
            setShowNewSalaryMonthPanel(false)
            setShowNewItemMonthPanel(false)
            setShowNewBenefitMonthPanel(true)
            setShowNewRevenueMonthPanel(false)
        }
    }

    function onUpdateInsertNewItem(value) {
        if (value) {
            setShowNewSalaryMonthPanel(false)
            setShowNewBenefitMonthPanel(false)
            setShowNewItemMonthPanel(true)
            setShowNewRevenueMonthPanel(false)
        }
    }

    function onUpdateInsertRevenue(value) {
        if (value) {
            setShowNewSalaryMonthPanel(false)
            setShowNewBenefitMonthPanel(false)
            setShowNewItemMonthPanel(false)
            setShowNewRevenueMonthPanel(true)
        }
    }

    function getPanelListCostDay() {
        return (
            < PanelListDefault
                onUpdateIdSelected={setCostDayIdSelecteds}
                idsSelected={costDayIdSelecteds}
                data={itemsDays}
                attributeList={attributeList}
            />
        )
    }

    function panelCostPerDay() {
        if (([4, 5]).includes(itemInValidation.key)) {
            return <SalaryDayPanelDetail
                itemInValidation={itemInValidation}
                costDayIdSelecteds={costDayIdSelecteds}
                onUpdateCostDayIdSelecteds={setCostDayIdSelecteds}
                updating={updating}
                dsItem={dsItem}
                dsMonth={dsMonth}
                onUpdateInsertSalary={onUpdateInsertSalary}
                setUpdating={setUpdating}
                showNewSalaryMonthPanel={showNewSalaryMonthPanel}
                handleClose={handleClose}
                getButtonToShowSubtitles={getButtonToShowSubtitles}
                panelListCostDay={getPanelListCostDay()}
                onUpdatePanelCostSpreadsheet={onUpdatePanelCostSpreadsheet}
                onUpdateReloadSalaryBenefitsCost={setReloadSalaryBenefitsCost}
            />
        } else if (([7]).includes(itemInValidation.key)) {
            return <RevenueDayPanel
                costDayIdSelecteds={costDayIdSelecteds}
                onUpdateCostDayIdSelecteds={setCostDayIdSelecteds}
                dsItem={dsItem}
                dsMonth={dsMonth}
                showNewRevenueMonthPanel={showNewRevenueMonthPanel}
                onUpdateInsertRevenue={onUpdateInsertRevenue}
                handleClose={handleClose}
                getButtonToShowSubtitles={getButtonToShowSubtitles}
                panelListCostDay={getPanelListCostDay()}
                onUpdatePanelCostSpreadsheet={onUpdatePanelCostSpreadsheet}
                onUpdateIdEmployee={setIdEmployee}
                onUpdateReloadSalaryBenefitsCost={setReloadSalaryBenefitsCost}
                itemInValidation={itemInValidation}
            />
        } else if (([6]).includes(itemInValidation.key)) {
            return <BenefitsDayPanel
                costDayIdSelecteds={costDayIdSelecteds}
                onUpdateCostDayIdSelecteds={setCostDayIdSelecteds}
                dsItem={dsItem}
                dsMonth={dsMonth}
                currentMonth={itemInValidation.currentMonth}
                showNewBenefitMonthPanel={showNewBenefitMonthPanel}
                onUpdateInsertBenefit={onUpdateInsertBenefit}
                handleClose={handleClose}
                getButtonToShowSubtitles={getButtonToShowSubtitles}
                panelListCostDay={getPanelListCostDay()}
                onUpdatePanelCostSpreadsheet={onUpdatePanelCostSpreadsheet}
                onUpdateIdEmployee={setIdEmployee}
                onUpdateReloadSalaryBenefitsCost={setReloadSalaryBenefitsCost}
            />
        } else if (([identifierExternalProduction]).includes(itemInValidation.key)) {
            return <ExternalEmployeeList
                costDayIdSelecteds={costDayIdSelecteds}
                onUpdateCostDayIdSelecteds={setCostDayIdSelecteds}
                dsItem={dsItem}
                dsMonth={dsMonth}
                currentMonth={itemInValidation.currentMonth}
                showNewBenefitMonthPanel={showNewBenefitMonthPanel}
                onUpdateInsertBenefit={onUpdateInsertBenefit}
                handleClose={handleClose}
                getButtonToShowSubtitles={getButtonToShowSubtitles}
                panelListCostDay={getPanelListCostDay()}
                onUpdatePanelCostSpreadsheet={onUpdatePanelCostSpreadsheet}
                onUpdateIdEmployee={setIdEmployee}
                onUpdateReloadSalaryBenefitsCost={setReloadSalaryBenefitsCost}
            />
        } else {
            return <CostDayPanelDetail
                itemInValidation={itemInValidation}
                costDayIdSelecteds={costDayIdSelecteds}
                onUpdateCostDayIdSelecteds={setCostDayIdSelecteds}
                updating={updating}
                dsItem={dsItem}
                dsMonth={dsMonth}
                onUpdateInsertNewItem={onUpdateInsertNewItem}
                setUpdating={setUpdating}
                showNewItemMonthPanel={showNewItemMonthPanel}
                handleClose={handleClose}
                getButtonToShowSubtitles={getButtonToShowSubtitles}
                panelListCostDay={getPanelListCostDay()}
                onUpdatePanelCostSpreadsheet={onUpdatePanelCostSpreadsheet}
                onUpdateReloadSalaryBenefitsCost={setReloadSalaryBenefitsCost}
            />
        }
    }

    function getMainPanelCosPerDay() {
        if (itemInValidation && closeCostSpreadsheet) {
            return (
                <Panel style={{ display: 'flex', flexDirection: 'column' }} className={'main-modal two right'}>
                    <LoadingIndicator loaded={dsMonth && dsItem} backgroundColor={'#f5f5f5'}>
                        <NewItemMonthPanel
                            itemInValidation={itemInValidation.key}
                            dsItem={dsItem}
                            currentMonth={itemInValidation.currentMonth}
                            showNewItemMonthPanel={showNewItemMonthPanel}
                            onUpdatePanelCostSpreadsheet={onUpdatePanelCostSpreadsheet}
                            onUpdateShowNewItemMonthPanel={setShowNewItemMonthPanel}
                            onUpdateReloadSalaryBenefitsCost={setReloadSalaryBenefitsCost}
                        />
                        <NewSalaryMonthPanel
                            itemInValidation={itemInValidation.key}
                            dsItem={dsItem}
                            currentMonth={itemInValidation.currentMonth}
                            showNewSalaryMonthPanel={showNewSalaryMonthPanel}
                            onUpdatePanelCostSpreadsheet={onUpdatePanelCostSpreadsheet}
                            onUpdateShowNewItemMonthPanel={setShowNewSalaryMonthPanel}
                            onUpdateReloadSalaryBenefitsCost={setReloadSalaryBenefitsCost}
                        />
                        <NewBenefitMonthPanel
                            itemInValidation={itemInValidation.key}
                            dsItem={dsItem}
                            idEmployee={idEmployee}
                            currentMonth={itemInValidation.currentMonth}
                            showBenefitMonthPanel={showNewBenefitMonthPanel}
                            onUpdatePanelCostSpreadsheet={onUpdatePanelCostSpreadsheet}
                            onUpdateShowNewBenefitMonthPanel={setShowNewBenefitMonthPanel}
                            onUpdateReloadSalaryBenefitsCost={setReloadSalaryBenefitsCost}
                        />
                        <LoadingIndicator loaded={itemsDays}>
                            {panelCostPerDay()}
                        </LoadingIndicator>
                    </LoadingIndicator>
                </Panel>
            )
        } else {
            return null
        }
    }

    return (
        <>
            {getMainPanelCosPerDay()}
        </>
    )
};

export default CostPerDay;
